export const ACCOUNT_MODE_CHANGED_EVENT = 'AccountModeChanged';

export type AccountModeChangedEventData = {
  mode: boolean;
};

// The backend only sends the event when the mode changes, so
// wait this long for a possible change
export const ACCOUNT_MODE_CHANGE_WINDOW = 3 * 1000;
// How long to wait for the account (and its stored mode) to load
export const ACCOUNT_LOAD_TIMEOUT = 5 * 1000;
